<template>
  <td>
    <div class="app-menu-pagina" :key="'titulo-' + time">
      Rotina Fácil<i class="fas fa-chevron-right"></i>
      <span v-if="$route.name === 'venda_numero'" v-html="appMenuFavoritoTitulo"></span>
      <span v-else-if="[ '', null, undefined ].indexOf($store.state.appTituloPagina) === -1" v-html="$store.state.appTituloPagina"></span>
    </div>

    <div class="app-menu-favorito">
      <draggable v-model="$store.state.favorito" :element="'div'" class="dragArea" @end="appMenuFavoritoAlterarPosicao" :disabled="$store.state.mobile === true">
        <div v-for="(item, indexF) in $store.state.favorito" :data-id='item.idmp' :key='"menu-favorito-" + indexF' @click="appMenuFavoritoAtualizaConteudo(item.rota)">
          <router-link :to='item.rota' :href='item.rota' tag='a' target="_parent" :data-id='item.idmp' class="separador">
            <table>
              <tr>
                <!-- SETA O ICONE DO BOTÃO -->
                <td>
                  <img :src='"/img/menu/" + item.idmp_img + ".png"' :alt='item.name' :title='item.name'>
                </td>

                <!-- SETA O NOME DO BOTÃO -->
                <td>
                  <!-- NOME DO PACOTE -->
                  <div v-html='item.m_principal' class="rf-texto"></div>

                  <!-- NOME DO BOTÃO -->
                  <div v-html='item.nome' class="rf-texto"></div>
                </td>

                <!-- SETA A NUMERAÇÃO  -->
                <td v-if='$store.state.menuInfo.filter(info => info.id === item.idmp).length >= 1' class="app-menu-info">
                  <template v-for='(info, indexI) in $store.state.menuInfo.filter(info => info.id === item.idmp)'>
                    <div :key="'info-' + info.id + '-' + indexI" :title="info.title" :class='"app-menu-info--" + info.color' @click="appMenuFavoritoAtualizaConteudo(info.busca + '--' + indexI)">
                      <router-link v-if="[ '', null, undefined ].indexOf(info.busca) === -1" :to='info.busca + "--" + indexI' :href='info.busca + "--" + indexI' target="_parent" tag='a' :key="'info-' + info.id + '-' + indexI" :title="info.title" :class='"app-menu-info--" + info.color'  > 
                        <span v-html="info.value"></span>
                      </router-link>
                      <span  v-else  v-html="info.value"></span>
                    </div>
                  </template>
                </td>
              </tr>
            </table>
          </router-link>
        </div>
      </draggable>
    </div>
  </td>
</template>

<style scoped>
.app-menu-pagina {
  color: #dadada;
  font-size: var(--font-base-soma-11);
  vertical-align: middle;
  margin-top: -0px;
  margin-left: -1px;
  padding: 2px 7px;
}
  .app-menu-pagina > svg,
  .app-menu-pagina > span > svg {
    margin: 0px 3px;
  }

/* CONFIGURAÇÃO FAVORITOS */
/* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
.rf-web-menu > header > .header-body > table > tr > td.web-menu-favorito {
  width: 100%;
}
  .app-menu-favorito > .dragArea {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;

    overflow-y: scroll;
    vertical-align: middle;
    color: #222;

    height: 46px;
    font-size: var(--font-base-soma-14);
    font-weight: 400;
    line-height: 20px;
  }

  /* CSS - BARRA DE ROLAGEM DO MENU FAVORITO */
/* ----------------------------------------------------------------------- */
.app-menu-favorito > .dragArea::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  border-right: none;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-thumb:active {
  background: #ffffff;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-track {
  background: #444444;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-track:hover {
  background: #444444;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-track:active {
  background: #444444;
}
.app-menu-favorito > .dragArea::-webkit-scrollbar-corner {
  background: transparent;
}
    .app-menu-favorito > .dragArea > div {
      display: inline-block;
    }
    .app-menu-favorito > .dragArea > div > a {
      height: 100%;
      display: inline-block;
      text-decoration: none;
      padding: 0px 6px;
      cursor: pointer;
      height: 46px;
      vertical-align: middle;
    }
      .app-menu-favorito > .dragArea > div > a > table {
        height: 100%;
        vertical-align: middle;
      }
        .app-menu-favorito > .dragArea > div > a > table > tr > td {
          color: #fff;
        }
        .app-menu-favorito > .dragArea > div > a > table > tr > td:first-child {
          padding: 0px 7px 0px 0px;
          margin: 0px;
        }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntMenuSetarFavorito: {
        required: true
      }
    },
    components: {
      draggable: require('vuedraggable')
    },
    data: function () {
      return {
        time: '',
        statusGeral: null,
        flag: false
      }
    },
    methods: {
      appMenuFavoritoAtualizaConteudo: function (rota) {
        // VERIFICA SE DEVE SETAR O FLAG PARA ATUALIZAR O COMPONENT
        if (rota.indexOf('/venda/nova') === -1 && rota.indexOf('/compra/nova') === -1) {
          this.$store.commit('SET_TIME_CONTEUDO', this.$router.resolve(rota))
        }

        // ABRE O CHAT, SE ELE ESTIVER FECHADO
        if (rota.indexOf('/reg-atendimentos') === -1 && [ '', null, undefined ].indexOf(this.$store.state.atalhos['ALT+A']) === -1 && this.$store.state.atalhos['ALT+A'].mostrar === true) {
          this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
        }
      },
      appMenuFavoritoAlterarPosicao: function (event) {
        this.cpntMenuSetarFavorito(event.clone.dataset.id, event.newIndex)
      }
    },
    computed: {
      appMenuFavoritoTitulo: function () {
        // INICIA A VARIAVEL
        var titulo = ''
        
        // VERIFICA SE TEM QUE MONTAR OS DADOS DA PAGINA
        if ([ '', null, undefined ].indexOf(this.$route) === -1 && [ '', null, undefined ].indexOf(this.$route.meta) === -1 && [ '', null, undefined ].indexOf(this.$route.meta.title) === -1) {
          titulo = this.$route.meta.title(this.$route)
        } else {
          titulo = this.$store.state.appTituloPagina
        }

        // REMOVE OS PONTOS DA STRING
        while (titulo.indexOf('->') > -1) {
          titulo = titulo.replace('->', '<i class=\'fas fa-chevron-right\'></i>')
        }
        
        // SETA O TITULO DA PAGINA
        return titulo
      }
    },
    watch: {
      '$route': function () {
        this.time = new Date().getTime()
      }
    }
  }
</script>
